import axios from '@/libs/api.request'

// 收支明细分页列表
export const apiBillDetailList = data => {
  return axios.request({
    url: '/billDetail/list',
    method: 'post',
    data
  })
}

// 新增/更新收支明细
export const apiBillDetailSave = data => {
  return axios.request({
    url: '/billDetail/save',
    method: 'post',
    data
  })
}

// 删除收支明细
export const apiBillDetailDelete = data => {
  return axios.request({
    url: '/billDetail/delete',
    method: 'post',
    data
  })
}

// 标记对账
export const apiBillDetailReconcile = data => {
  return axios.request({
    url: '/billDetail/reconcile',
    method: 'post',
    data
  })
}
